// ═══════════════════════════════════════════
//  PHONE NUMBER VALIDATION — Indian mobiles
// ═══════════════════════════════════════════
// One rule for every phone / mobile field in the app: exactly 10 digits,
// starting with 6-9. Landlines and international numbers are not accepted.

export const PHONE_ERROR = 'Enter a valid 10-digit mobile number';

// For the HTML `pattern` attribute (native browser validation).
export const PHONE_PATTERN = '[6-9][0-9]{9}';

// Strips anything that is not a digit, drops a pasted country code (+91) or a
// leading 0, and caps the result at 10 digits. Use this in onChange so a bad
// value can never be typed in the first place.
export const sanitizePhone = (raw = '') => {
  let d = String(raw).replace(/\D/g, '');
  if (d.length > 10 && d.startsWith('0')) d = d.replace(/^0+/, '');
  if (d.length > 10 && d.startsWith('91')) d = d.slice(2);
  return d.slice(0, 10);
};

// True when the value is a valid Indian mobile number.
export const isValidPhone = (v = '') => /^[6-9]\d{9}$/.test(sanitizePhone(v));

// For optional fields: empty passes, anything entered must be valid.
export const isValidOptionalPhone = (v = '') => !String(v).trim() || isValidPhone(v);

// Props shared by every plain (non react-hook-form) phone input.
export const phoneInputProps = {
  type: 'tel',
  inputMode: 'numeric',
  maxLength: 10,
  autoComplete: 'tel',
};
